<script lang="ts">
  import { useActions, type HTMLActionArray } from "#lib/internal/helpers"
  import type { Snippet } from "svelte"
  import { bodyCellVariants, cn } from ".."
  import { getTableRootContext } from "./Table.svelte"

  const rootCtx = getTableRootContext()

  type Props = {
    allowTextOverflow?: boolean
    title?: string
    span?: number
    use?: HTMLActionArray
    class?: string
    headerLabel?: Snippet
    children?: Snippet
    [key: string]: unknown
  }

  let {
    allowTextOverflow = false,
    title = undefined,
    span = undefined,
    use = [],
    class: cssClass = "",
    headerLabel,
    children,
    ...restProps
  }: Props = $props()

  let ref: HTMLDivElement = $state()!

  const cellIndex = $derived(
    Array.prototype.indexOf.call(ref?.parentElement?.children ?? [], ref)
  )
</script>

<div
  bind:this={ref}
  class={cn(
    bodyCellVariants({
      variant: $rootCtx.variant,
      responsive: $rootCtx.responsive,
    }),
    cssClass
  )}
  {title}
  class:truncate={!allowTextOverflow}
  role="cell"
  data-fixed-span={span ?? Number.NaN}
  use:useActions={use}
  {...restProps}
>
  {#if $rootCtx.responsive}
    <span class="pr-3 uppercase text-general-secondary-text md:hidden">
      {#if headerLabel}{@render headerLabel()}{:else}
        {$rootCtx.headerLabels[cellIndex] || "Action"}:
      {/if}
    </span>
  {/if}

  {@render children?.()}
</div>
